import { Inject, Injectable, PLATFORM_ID, ɵNOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {APP_SETTINGS } from '../../../modules/ng-express-engine/tokens';
import { Actions, Effect } from '@ngrx/effects';
import { Action, Store, select } from '@ngrx/store';
import * as fromRoot from '../reducer/core.reducer';

import * as coreActions from '../action/core.actions';
import { StateInteractionService } from '../../service/dynamic/state.interaction.service';
import { UndoRedoStack } from '../../service/util/undo.redo.stack';
import { EventInteraction } from '../../service/dynamic/event.interaction.service';
import { pluck, takeWhile, takeUntil } from 'rxjs/operators';

@Injectable()
export class StateInternalPipe {

    constructor(
        @Inject(APP_SETTINGS) private settings: Object,
        private store: Store<fromRoot.State>,
        private actions$: Actions,
        private stateInteraction: StateInteractionService,
        private eventInteraction: EventInteraction,
        private undoRedoStack: UndoRedoStack
    ){

    }

    public setInternalStateValue(key: string, value:any){
        this.store.dispatch(new coreActions.SetInternalStateValue({ key: key, value: value }));
     }
   
    public getInternalStateValue(key: string):any{
        return this.stateInteraction.getInternalStateValue(key);
    }

    public setPopState(val, url){
        const popState = { popState: val, from: url };
        this.setInternalStateValue( 'popState', popState);
    }

    public getPopState(){
      const popState = this.getInternalStateValue('popState2');
      return (popState) ? popState.popState : false;
    }

    public setPopState2(val, url){
        const popState = { popState: val, from: url };
        this.setInternalStateValue( 'popState2', popState);
    }

    public processSlugState(routeParams: any, url : string){
        const passedInternalSlugVal = this.getLastParam(routeParams);
        const existingInternalStateVal = this.getInternalStateValue('selectedSlug');
        if (existingInternalStateVal != passedInternalSlugVal){
          if ((!passedInternalSlugVal || passedInternalSlugVal.trim() == '') && (url != '/' && url != '/home')){
            return existingInternalStateVal;
          }
          else{
            this.setInternalStateValue( 'selectedSlug', passedInternalSlugVal);
            return passedInternalSlugVal;
          }
        }
        else{
          return existingInternalStateVal;
        }
       
    }

    public processHistoryState(routeParams: any){
        const passedInternalSlugVal = this.getLastParam(routeParams);
        const existingInternalStateVal = this.getInternalStateValue('selectedSlug');
        if (existingInternalStateVal != passedInternalSlugVal){
          this.setInternalStateValue( 'selectedSlug', passedInternalSlugVal);
        }
        return passedInternalSlugVal;
    }

    private getLastParam(routeParams: any){
        const keys = Object.keys(routeParams);
        if (keys.length > 0){
          return routeParams[keys[keys.length -1]];
        }
        else{
          return '';
        }
    }

    public checkAndSetInternalStateSelectedSlug(val? : any){
        if (!val){
            val = [];
        }
        const existingInternalStateVal = this.getInternalStateValue('selectedSlug');
        if (val != existingInternalStateVal){
          this.setInternalStateValue( 'selectedSlug', val);
        }
    }

    private createPlaylistRoute(source: Object) : Object {
        if (source['internal_route']){
          if(this.isPlayableAsList(source) && source['internal_route'].indexOf('lists/') > -1){
            source['playlist_internal_route'] = source['internal_route'].replace('lists/', 'playlists/');
          }
        }
        return source;
    }

    private isPlayableAsList(row: Object){
        let isVideo = row["meta"] && row["meta"]["any_playable"];
        return isVideo;
    }

    private createDefaultInternalState(rows :Array<any>) : Object {
        //const render_types = this.settings._slider_state_paths;
        let stateObj = { 
            coordinates: this.settings['DEFAULT_COORDINATES']
        };
        for (let row of rows){
            if (row['meta']){
            //if (row['meta']['render_style'] && (render_types.indexOf(row['meta']['render_style']) > -1)){
            row['selected'] =  (k == this.settings['DEFAULT_SLIDER_INDEX'])  ? true : false;
            if (1==1){
                stateObj[row['meta']['slug']] = { slide_index: this.settings['DEFAULT_SLIDER_INDEX'] };
                if(row['data']){
                for (var k = 0; k < row['data'].length; k++){
                    row['data'][k]['selected'] =  (k == this.settings['DEFAULT_SLIDER_INDEX'])  ? true : false;
                }
                }
            }
            }
        }
        return stateObj;
    }      

    public wasPopped(popState){
        if (!popState){
          this.setInternalStateValue('popState2', false);
          return false;
        }
        if (!popState.popState){
          this.setInternalStateValue('popState2', false);
          return false;
        }
        return true;
    }

    private addInternalRouteBySlugMatch(source, removeItem){
        var res = Object.assign({}, source);
        if (res['meta']){
          const slug = res.meta.slug;
          let internalRoute = res.meta['internal_route'];
          let getUrl = res.meta['get_url'];
          if (!internalRoute){
            internalRoute = res['internal_route'];
            getUrl = res['get_url']
          }
          if (slug){
            if (res['data'] && Array.isArray(res['data'])){
              for (let item of res['data']){
                let itemMeta = item['meta'];
                if (itemMeta && itemMeta['slug'] == slug && itemMeta['obj_type'] == res.meta['obj_type']){
                  if (internalRoute && (!itemMeta['internal_route'])){
                    itemMeta['internal_route'] = internalRoute.replace(removeItem, '');
                    itemMeta['get_url'] = getUrl.replace(removeItem, '');
                  }
                }
              }
            }
          }
        }
        return res;
    }

    private isMatchedRoute(reverseConfig: Object, url: string, routeParams: Object){
        let isMatch = true;
        if (url.indexOf(reverseConfig['routeRoot']) < 0) {
          isMatch = false;
        }
        if (Object.keys(routeParams).length != reverseConfig['slugCount']){
          isMatch = false;
        }
        return isMatch;
    }

    public getRowMetaFlags(sourceObject: Object,url: string, routeParams: object){
        let result = Object.assign({}, sourceObject);
        let hasData = false;
        let needsSearchBox = false;
        if (url && (url.indexOf('search') > -1 || url.indexOf('tags') > -1)){
          hasData = true;
        }
        else{
          if(result['data'] && Array.isArray(result['data']) && result['data'].length > 0){
            hasData = true;
          }
        }
        if (url && url.indexOf('search') > -1){
          needsSearchBox = true;
        }
    
        if (result['meta']){
          result['meta']['metaFlags'] = { hasData: hasData, needsSearchBox: needsSearchBox };
        }
    
        if (result['rows'] && Array.isArray(result['rows'])){
          let rowArray = [];
          for (let row of result['rows']){
            rowArray.push(this.getRowMetaFlags(row, url, {}));
          }
          result['rows'] = [].concat(rowArray);
        }
    
        return result;
    }

    public keepOverrides(overridingMeta: any, result: any){
        if (this.settings['KEEP_META_OVERRIDES'] && overridingMeta && result['meta']){
          const propsToKeep = this.settings['KEEP_META_OVERRIDES'] as Array<string>;
          for (let prop of propsToKeep){
            if (overridingMeta[prop]){
              result['meta'][prop] = overridingMeta[prop];
            }
          }
        }
        return result;
    }

    private matchRouteSlug(currentSlug: string, item: any){
      if (item['meta'] && item['meta']['slug']){
        if (item['meta']['slug'] == currentSlug){
          item['meta']['active'] = true;
          //console.log("slug match found");
        }
        else{
          item['meta']['active'] = false;
        }
      }
    }

    public handleInternalState(source: Object, routeParams: any, url: string, isContainer: boolean, notify: boolean, overridingMeta: any, maxCount? : number){
      const currentSlug = this.processSlugState(routeParams, url); 
      let isDefault = true;
      let internalState = source['internal_state'];
      if (!internalState){
        internalState = {
          internal_state: { 
            active_route_slug: currentSlug
          }
        };
        source = Object.assign(source, internalState);
        internalState = source['internal_state'];
      }
      let commonInternalState = this.getInternalStateValue('undo_stack');
      //console.log('mures');
      //console.log(commonInternalState);
      if (!commonInternalState){
        commonInternalState = this.undoRedoStack.init();
      }
      //console.log('olt');
      //console.log(commonInternalState);
      if (isContainer){
        let stateObj;
        let rows = source['rows'];
        if (!rows || (Array.isArray(rows) == false)) {
          rows = [];
        }    
        for (let r = 0; r < rows.length; r++){
          const result1 = source['rows'][r];
          if (result1['meta'] && result1['data'] && result1['meta']['slug']){
            for (let item of result1['data']){
              item['meta_slug'] = result1['meta']['slug'];
            }
          }
          this.matchRouteSlug(currentSlug, result1);
          if (result1['data'] ){
            for (let item of result1['data']){
              this.matchRouteSlug(currentSlug, item);
            }
          }
        }
        if (source['data']){
          for (let item of source['data']){
            this.matchRouteSlug(currentSlug, item);
          }
        }

        if (url.indexOf('lists/') > -1){
          source = this.createPlaylistRoute(source);
        }  
        const popState = this.getInternalStateValue('popState');
        if (this.wasPopped(popState)){
          this.setPopState(false, url);
          this.setPopState2(true, url);
          commonInternalState = this.undoRedoStack.pop(commonInternalState, url);
          let currentState = commonInternalState.present;
          stateObj = (currentState && currentState.isDefault) ? this.createDefaultInternalState(rows) : currentState;      
        }
        else{
          stateObj = this.createDefaultInternalState(rows);
          var outsideStateObj = { isDefault: true, url: url, date: new Date() };
          commonInternalState = this.undoRedoStack.add(commonInternalState, outsideStateObj);
        }
        //source = this.trimRows(source, url);
        this.setInternalStateValue('undo_stack', commonInternalState);
        internalState['currentState'] = stateObj;
        internalState['selected_slug'] = internalState.active_route_slug;
      }
      else{
        let dataList; 
        if (source['data'] && Array.isArray(source['data'])){
          dataList = source['data'] as Array<Object>;
          if (maxCount){
            dataList = dataList.slice(0, maxCount + 1);
            source['data'] = dataList;
          }
          source = this.createPlaylistRoute(source);
          source = this.addInternalRouteBySlugMatch(source, '/flattened');
          const reverseConfigArray = this.settings['REVERSE_DATA_ROUTES'];
          for (let reverseConfig of reverseConfigArray){
             if (this.isMatchedRoute(reverseConfig, url, routeParams)){
               if (source['meta'] && source['meta']['obj_type'] && source['meta']['obj_type'] == reverseConfig['obj_type']){
                 if (source['data'] && Array.isArray(source['data'])) {
                   const season =  source['data'].filter(row => row['meta']['obj_type'] == 'Season');
                   const episodes =  source['data'].filter(row => row['meta']['obj_type'] == 'Episode').reverse();
                   source['data'] = season.concat(episodes);
                 }
               }
             }
          }
          if (source['meta']){
            const nextPageUrl = source['meta'][this.settings['NEXT_PAGE_URL']];
            if (nextPageUrl){
              this.store.dispatch(new coreActions.LoadDataItemAction({ routeParams: routeParams, apiUrl: source[nextPageUrl] }));
              source['last_page'] = source[nextPageUrl];
            }
          }
        }
      }
      const resWithFlags = this.getRowMetaFlags(source, url, {});
      //const result = Object.assign({}, resWithFlags);
      const resString = JSON.stringify( resWithFlags );
      const result = JSON.parse( resString );
      //this.store.dispatch(new coreActions.SetInternalStateValue(result));
      if (notify){
        this.eventInteraction.next({ key: "data loaded", message: true  });
      }
      this.matchRouteSlug(currentSlug, result);
      if (result['data']){
        for (let item of result['data']){
          this.matchRouteSlug(currentSlug, item);
        }
      }
      let newState = this.keepOverrides(overridingMeta, result);
      this.changeToPlaylist(newState);
      this.correctVideoMetaInternalRoute(newState);
      if(this.settings['AUTH_ENABLED']){
        newState = this.setVideoStats( newState );
        //console.log(newState);
      }
      return newState;
    }

    private isPlaylistRenderStyle(rStyle: string) : boolean{
      if (this.settings['IMPLICIT_PLAYLIST_ROUTES']){
        const iprRenderStyleList = this.settings['IMPLICIT_PLAYLIST_ROUTES_RENDER_STYLES'] as Array<string>;
        if (iprRenderStyleList.includes('all')){
          return true;
        }
        else if(iprRenderStyleList.includes(rStyle)){
          return true;
        }
        else{
          return false;
        }
      }
      else{
        return false;
      }
    }

    private changeToPlaylist(result){
      if ((result['meta'] && result['meta']['render_style']) 
        &&  this.isPlaylistRenderStyle(result['meta']['render_style'].toLowerCase())){
        if (result['data']){
          for (let item of result['data']){
            if((item['meta']['obj_type'] == "Video" || item['meta']['obj_type'] == "Episode"))
            {
              this.createPlaylistRoute(result);
              item['internal_route'] = result['playlist_internal_route'] + item['meta']['internal_route'];
              item['meta']['internal_route'] = item['internal_route'];
            }
          }
        }
      }
    }

    private correctVideoMetaInternalRoute(result){
      if (result['data']){
        for (let item of result['data']){
          let correctRoute = null;
          if (item['internal_route']){
            correctRoute = item['internal_route'];
          }
          else if (item['meta'] && item['meta']['internal_route']){
            correctRoute = item['meta']['internal_route']; 
          }
          if (correctRoute && item['meta'] && item['meta']['video'] && item['meta']['video']['meta']){
            if (correctRoute != item['meta']['video']['meta']['internal_route']){
              item['meta']['video']['meta']['internal_route'] = correctRoute;
            }
          }
        }
      }
    }
    
    private setVideoStats(newResult: any) {
      const videoStats = this.getInternalStateValue("video_stats");
      const self = this;
      let id : string;
      let video : object;
      //let newResult = Object.assign(result);
      if( videoStats){
        if(newResult.meta){
          if ( newResult.meta.obj_type != "Episode" ){
            id = newResult.meta.unique_id;
            video = newResult;
          }
          else if( newResult.meta.obj_type == "Episode" && newResult.meta.video && newResult.meta.video.meta){
            id = newResult.meta.video.meta.unique_id;
            video = newResult.meta.video;
          }
    
          if( id && videoStats[id] ){
             self.updateVideoObjectStats( videoStats[id], video, newResult.meta);
          }
        } 
  
        if(newResult.rows){
          newResult.rows.forEach(row=> {
            if( row.data && row.data.length > 0 ){
              this.crawlData( videoStats, row)
            } 

          })
        }
        
        if( newResult.data ){
          this.crawlData( videoStats, newResult );
        }
      }
      return newResult;
    };

    protected crawlData( videoStats, items ){
      const self = this;

      items.data.forEach( item => {
        let id;
        let video;
        
        if ( item.meta.obj_type != "Episode" ){
          id = item.meta.unique_id;
          video = item;
        }
        else if( item.meta.obj_type == "Episode" && item.meta.video && item.meta.video.meta){
          id = item.meta.video.meta.unique_id;
          video = item.meta.video
        }
  
        if( id && videoStats[id] ){
           self.updateVideoObjectStats( videoStats[id], video, item.meta);
        }
      });
    }
    
    protected updateVideoObjectStats(stat , video, meta){
      video.meta.duration_watched  = stat.meta.duration_watched;
      video.meta.percent_played    = stat.meta.percent_played;
      video.meta.complete          = stat.meta.complete;
      video.meta.liked             = stat.meta.liked;
      meta.internal_route_timestamped = meta.internal_route + "?t=" + stat.meta.duration_watched;
      //console.log( item )
    }

    public handleInternalStateAndMerge(source: Object, routeParams: any, url: string, isContainer: boolean, notify: boolean, initialData: Array<Object>){
      let res  = this.handleInternalState(source, routeParams, url, isContainer, notify, null);
  
      res['data'].forEach(item=>{
        item.outOfScope = true;
      });
      
      res['data'] = initialData.concat(res['data']);
      return res['data'];
    }      
  
}



// WEBPACK FOOTER //
// ./src/angular-engine/engine/state/effect/state-internal.pipe.ts